import React from "react";
import { MessageCircle } from "lucide-react";
import { BOOKING_URL, CONTACT } from "../mock/mock";

export default function FloatingActions() {
  return (
    <>
      <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="book-badge hidden md:inline-flex">
        Book Direct &middot; Best Rate
      </a>
      <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="wa-badge" aria-label="WhatsApp">
        <MessageCircle size={22} />
      </a>
    </>
  );
}
